/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */



angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodDay_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl+'rest/workingPeriodDays/:id',{}, {});
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodDay',["WorkingPeriodDayHr","WorkingPeriodDayPr","WorkingPeriodDayData","WorkingPeriodDay_Resource",
        function (WorkingPeriodDayHr,WorkingPeriodDayPr,WorkingPeriodDayData,WorkingPeriodDay_Resource)
        {
        //WorkingPeriodDay inherit of $resource

        var  WorkingPeriodDay = function (resource,workingPeriod, isApplicationLoading)
        {
            this.id = null;
            this.openDay = false;
            this.workingPeriod = null;
            this.workingPeriodDayHrs = [];
            this.workingPeriodDayPrs = [];

            WorkingPeriodDayData.add(this);

            if (workingPeriod!==undefined && workingPeriod!=null)
                this.workingPeriod = workingPeriod;

            if (resource!==undefined && resource!=null)
            {
                this.loadObject(resource, isApplicationLoading);
            }
        }
        WorkingPeriodDay.prototype.loadObject = function(object, isApplicationLoading)
        {
            if (!this.id)
                this.id = object.id;
            this.openDay = object.openDay;
            if (object.workingPeriodDayHrs)
                for (var i =0;i< object.workingPeriodDayHrs.length;i++)
                    this.workingPeriodDayHrs.push(new WorkingPeriodDayHr(object.workingPeriodDayHrs[i],this, isApplicationLoading));
            if (object.workingPeriodDayPrs)
                for (var i =0;i< object.workingPeriodDayPrs.length;i++)
                    this.workingPeriodDayPrs.push(new WorkingPeriodDayPr(object.workingPeriodDayPrs[i],this, isApplicationLoading));
        };
        WorkingPeriodDay.prototype.getObjectResource = function(saveChild)
        {
            var wpDayRes = new WorkingPeriodDay_Resource();
            wpDayRes.id = this.id;
            wpDayRes.openDay = this.openDay;

            if (this.workingPeriod)
                wpDayRes.workingPeriodId=this.workingPeriod.id;
            if (saveChild!==undefined && saveChild) {
                wpDayRes.workingPeriodDayHrs = [];
                wpDayRes.workingPeriodDayPrs = [];
                if (this.workingPeriodDayHrs)
                    for (var i = 0; i < this.workingPeriodDayHrs.length; i++)
                        wpDayRes.workingPeriodDayHrs.push(this.workingPeriodDayHrs[i].getObjectResource());
                if (this.workingPeriodDayPrs)
                    for (var i = 0; i < this.workingPeriodDayPrs.length; i++)
                        wpDayRes.workingPeriodDayPrs.push(this.workingPeriodDayPrs[i].getObjectResource());
            }
            return  wpDayRes;
        };
        WorkingPeriodDay.prototype.setId = function(id)
        {
            this.id = id;
        };
        WorkingPeriodDay.prototype.getId = function()
        {
            return this.id;
        };
        WorkingPeriodDay.prototype.indexOfWorkingPeriodDayHr= function(humanResourceId)
        {
            for (var i=0;i<this.workingPeriodDayHrs.length;i++)
                if (this.workingPeriodDayHrs[i].humanResourceId==humanResourceId)
                    return i;
            return -1;
        };
        WorkingPeriodDay.prototype.getWorkingPeriodDayHr= function(humanResourceId)
        {
            var index = this.indexOfWorkingPeriodDayHr(humanResourceId);
            if (index!=-1)
                return this.workingPeriodDayHrs[index];
            return null;
        };
        WorkingPeriodDay.prototype.createAndAddWorkingPeriodDayHr = function(humanResourceId)
        {
            var wpDayHr =null;
            if (this.indexOfWorkingPeriodDayHr(humanResourceId)==-1)
            {
                wpDayHr = new WorkingPeriodDayHr(null,this);
                wpDayHr.humanResourceId = humanResourceId;
                this.workingPeriodDayHrs.push(wpDayHr);
            }
            return wpDayHr;
        };
            
        WorkingPeriodDay.prototype.removeWorkingPeriodDayHr = function(workingPeriodDayHr)
        {
            var index = this.workingPeriodDayHrs.indexOf(workingPeriodDayHr);
            if (index!=-1)
            {
                this.workingPeriodDayHrs.splice(index,1);
                //workingPeriodDayHr.workingPeriodDay = null;NOT REMOVE BECAUSE USED BY CANCEL
            }

        };
        WorkingPeriodDay.prototype.removeWorkingPeriodDayHrByHrId = function(humanResourceId)
        {
            var index = this.indexOfWorkingPeriodDayHr(humanResourceId);
            if (index!=-1)
            {
                this.workingPeriodDayHrs.splice(index,1);

            }

        };
        WorkingPeriodDay.prototype.indexOfWorkingPeriodDayPr= function(physicalResourceId,prUnitId)
        {
            for (var i=0;i<this.workingPeriodDayPrs.length;i++)
                if (this.workingPeriodDayPrs[i].physicalResourceId==physicalResourceId && this.workingPeriodDayPrs[i].prUnitId==prUnitId)
                    return i;
            return -1;
        };
        WorkingPeriodDay.prototype.getWorkingPeriodDayPr= function(physicalResourceId,prUnitId)
        {
            var index = this.indexOfWorkingPeriodDayPr(physicalResourceId,prUnitId);
            if (index!=-1)
                return this.workingPeriodDayPrs[index];
            return null;
        };
        WorkingPeriodDay.prototype.createAndAddWorkingPeriodDayPr = function(physicalResourceId,prUnitId)
        {
            var wpDayPr =null;
            if (this.indexOfWorkingPeriodDayPr(physicalResourceId,prUnitId)==-1)
            {
                wpDayPr = new WorkingPeriodDayPr(null,this);
                wpDayPr.physicalResourceId = physicalResourceId;
                wpDayPr.prUnitId = prUnitId;
                this.workingPeriodDayPrs.push(wpDayPr);
            }
            return wpDayPr;
        };

        WorkingPeriodDay.prototype.removeWorkingPeriodDayPr = function(workingPeriodDayPr)
        {
            var index = this.workingPeriodDayPrs.indexOf(workingPeriodDayPr);
            if (index!=-1)
            {
                this.workingPeriodDayPrs.splice(index,1);
                //workingPeriodDayPr.workingPeriodDay = null;NOT REMOVE BECAUSE USED BY CANCEL
            }

        };
        WorkingPeriodDay.prototype.removeWorkingPeriodDayPrByPrId = function(humanResourceId)
        {
            var index = this.indexOfWorkingPeriodDayPr(humanResourceId);
            if (index!=-1)
            {
                this.workingPeriodDayPrs.splice(index,1);

            }

        };
        return WorkingPeriodDay;
    }
    ]);
angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodDaySrv',["$log","ServerSrv", function ($log,ServerSrv)
    {
        var  workingPeriodDaySrv = {};

        workingPeriodDaySrv.save =  function(workingPeriodDay,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(workingPeriodDaySrv.saveSync, workingPeriodDay, successFunction, errorFunction);
        };
        workingPeriodDaySrv.saveSync =  function(workingPeriodDay,successFunction,errorFunction)
        {
            //$timeout (function () {

            var workingPeriodDayRes = workingPeriodDay.getObjectResource();
            workingPeriodDayRes.$save({}, //no params
                function (data) {
                    try{
                        workingPeriodDay.setId(data.id);

                        //Add user action
                        //UserActionSrv.add(data.userAction);
                        //CallBack on success
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };

        return workingPeriodDaySrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodDayData',[ function ()
    {
        var  workingPeriodDayData =
        {
            indexWorkingPeriodDays : []
        };
        workingPeriodDayData.getById =  function(workingPeriodDayId)
        {
            for (var i=0;i<this.indexWorkingPeriodDays.length;i++)
                if (this.indexWorkingPeriodDays[i].id==workingPeriodDayId)
                    return this.indexWorkingPeriodDays[i];
            return null;
        }
        workingPeriodDayData.getByIndex =  function(servIndex)
        {
            if (servIndex>=0 && servIndex<this.indexWorkingPeriodDays.length)
                return this.indexWorkingPeriodDays[servIndex];
            else
                return null;
        }
        workingPeriodDayData.getIndexOf =  function(workingPeriodDay)
        {
            if (workingPeriodDay)
                return this.indexWorkingPeriodDays.indexOf(workingPeriodDay);
            return -1;
        }
        workingPeriodDayData.add =  function(workingPeriodDay)
        {
            this.indexWorkingPeriodDays.push(workingPeriodDay);
            return this.indexWorkingPeriodDays.length-1;
        }
        workingPeriodDayData.clear =  function()
        {
            workingPeriodDayData.indexWorkingPeriodDays = [];
        }
        return workingPeriodDayData;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/WorkingPeriodDay.js